export const adminUsers = {
  'admin.users.title': 'Kullanıcı Yönetimi',
  'admin.users.subtitle': 'Kullanıcı hesaplarını, istatistikleri ve performansı yönetin ve izleyin',
  'admin.users.loading': 'Yükleniyor...',
  'admin.users.error': 'Kullanıcı verileri yüklenirken hata',
  'admin.users.noData': 'Veri mevcut değil',
  'admin.users.cards.totalUsers.title': 'Toplam Kullanıcılar',
  'admin.users.cards.totalUsers.active': 'Aktif',
  'admin.users.cards.totalUsers.inactive': 'Pasif',
  'admin.users.cards.monthlyUsers.title': 'Bu Ay Yeni Kullanıcılar',
  'admin.users.cards.monthlyUsers.dailyRegistrations': 'Bugünkü Kayıtlar',
  'admin.users.cards.usersWithoutAccounts.title': 'Hesapsız Kullanıcılar',
  'admin.users.cards.usersWithoutAccounts.withInactiveAccounts': 'Pasif Hesaplı Kullanıcılar',
  'admin.users.cards.countryDistribution.title': 'En Çok Ülke',
  'admin.users.cards.countryDistribution.topCountry': 'Birinci Ülke',
  'admin.users.cards.countryDistribution.usersCount': 'Kullanıcı Sayısı',
  'admin.users.cards.countryDistribution.noData': 'Veri mevcut değil',
  'admin.users.cards.topEarnersCombined.title': 'En Çok Kazanan (Birleşik)',
  'admin.users.cards.topEarnersCombined.description': 'Trading + Komisyon Kârları',
  'admin.users.cards.topEarnersAccounts.title': 'En Çok Trading Hesap Kazananları',
  'admin.users.cards.topEarnersAccounts.description': 'Trading Hesap Kârları',
  'admin.users.cards.topEarnersCommissions.title': 'En Çok Komisyon Kazananları',
  'admin.users.cards.topEarnersCommissions.description': 'Topluluk Komisyon Kârları',
  'admin.users.tables.recent.title': 'Son Kullanıcılar (Son 7 Gün)',
  'admin.users.tables.inactive.title': 'Pasif Kullanıcılar',
  'admin.users.tables.no_accounts.title': 'Hesapsız Kullanıcılar',
  'admin.users.tables.inactive_accounts.title': 'Pasif Hesaplı Kullanıcılar',
  'admin.users.tables.columns.username': 'Kullanıcı Adı',
  'admin.users.tables.columns.name': 'Ad',
  'admin.users.tables.columns.country': 'Ülke',
  'admin.users.tables.columns.status': 'Durum',
  'admin.users.tables.columns.joinedAt': 'Katılım Tarihi',
  'admin.users.tables.columns.accountCreationDate': 'Hesap Oluşturma',
  'admin.users.tables.columns.accountNumber': 'Hesap Numarası',
  'admin.users.tables.columns.accountStatus': 'Hesap Durumu',
  'admin.users.tables.columns.actions': 'İşlemler',
  'admin.users.tables.status.active': 'Aktif',
  'admin.users.tables.status.inactive': 'Pasif',
  'admin.users.tables.accountStatus.active': 'Aktif',
  'admin.users.tables.accountStatus.inactive': 'Pasif',
  'admin.users.tables.accountStatus.pending': 'Beklemede',
  'admin.users.tables.accountStatus.suspended': 'Askıya Alınmış',
  'admin.users.tables.accountStatus.closed': 'Kapalı',
  'admin.users.tables.pagination.previous': 'Önceki',
  'admin.users.tables.pagination.next': 'Sonraki',
  'admin.users.tables.pagination.loadMore': 'Daha Fazla Yükle',
  'admin.users.tables.pagination.showing': 'Gösterilen',
  'admin.users.tables.pagination.of': '/',
  'admin.users.tables.pagination.results': 'sonuç',
  'admin.users.tables.pagination.page': 'Sayfa',
  'admin.users.tables.error': 'Tablo verileri yüklenirken hata',
  'admin.users.tables.noData': 'Veri mevcut değil',
  'admin.users.tables.noAccount': 'Hesap Yok',
  'admin.users.tables.unknown': 'Bilinmiyor',
  'admin.users.tables.viewProfile': 'Profili Görüntüle',
  'admin.users.search.title': 'Kullanıcı Arama',
  'admin.users.search.subtitle': 'Çeşitli kriterlere göre kullanıcı arayın ve bulun',
  'admin.users.search.form.userInfo.label': 'Kullanıcı Bilgileri',
  'admin.users.search.form.userInfo.placeholder': 'Kullanıcı adı, ad, e-posta veya telefona göre arayın...',
  'admin.users.search.form.country.label': 'Ülke',
  'admin.users.search.form.country.placeholder': 'Bir ülke seçin...',
  'admin.users.search.form.country.all': 'Tüm Ülkeler',
  'admin.users.search.form.searchButton': 'Ara',
  'admin.users.search.form.clearButton': 'Temizle',
  'admin.users.search.results.title': 'Arama Sonuçları',
  'admin.users.search.results.noResults': 'Kriterlerinize uygun kullanıcı bulunamadı',
  'admin.users.search.results.loading': 'Kullanıcılar aranıyor...',
  'admin.users.search.results.error': 'Kullanıcı aramasında hata',
  'admin.users.search.results.showEmail': 'E-postayı Göster',
  'admin.users.search.results.hideEmail': 'E-postayı Gizle',
  'admin.users.search.results.showPhone': 'Telefonu Göster',
  'admin.users.search.results.hidePhone': 'Telefonu Gizle',
  'admin.users.search.results.columns.email': 'E-posta',
  'admin.users.search.results.columns.phone': 'Telefon',
  
  'admin.users.profile.title': 'Kullanıcı Profili',
  'admin.users.profile.subtitle': 'Detaylı kullanıcı bilgilerini ve ayarlarını görüntüleyin',
  'admin.users.profile.error.userNotFound': 'Kullanıcı bulunamadı. Belirtilen kullanıcı adı mevcut değil.',
  'admin.users.profile.loading': 'Kullanıcı profili yükleniyor...',
  
  'admin.users.profile.info.title': 'Profil Bilgileri',
  'admin.users.profile.info.username': 'Kullanıcı Adı',
  'admin.users.profile.info.name': 'Ad',
  'admin.users.profile.info.status': 'Kullanıcı Durumu',
  'admin.users.profile.info.memberSince': 'Üyelik Başlangıcı',
  'admin.users.profile.info.sponsor': 'Sponsor',
  'admin.users.profile.info.referralLink': 'Referans Bağlantısı',
  'admin.users.profile.info.commissionModel': 'Komisyon Modeli',
'admin.users.profile.info.country': 'Ülke',
  'admin.users.profile.info.domain': 'Alan Adı',
  'admin.users.profile.info.internalCommissionModel': 'Dahili Komisyon Modeli',
  'admin.users.profile.info.communityLevel': 'Topluluk Kademesi',
  'admin.users.profile.info.genealogyTree': 'Topluluk Soy Ağacı',
  'admin.users.profile.info.openUserTree': 'Kullanıcının Ağacını Aç',
  'admin.users.profile.info.copyReferralLink': 'Referans Bağlantısını Kopyala',
  'admin.users.profile.info.viewSponsor': 'Sponsor Profilini Görüntüle',
  'admin.users.profile.info.noData': 'Profil bilgileri mevcut değil.',
  
  'admin.users.profile.status.editButton': 'Durumu Düzenle',
  'admin.users.profile.status.saveButton': 'Kaydet',
  'admin.users.profile.status.cancelButton': 'İptal',
  'admin.users.profile.status.saving': 'Kaydediliyor...',
  'admin.users.profile.status.active': 'Aktif',
  'admin.users.profile.status.inactive': 'Pasif',
  'admin.users.profile.status.updateSuccess': 'Durum Güncellendi',
  'admin.users.profile.status.updateSuccessDescription': 'Kullanıcı durumu başarıyla güncellendi.',
  'admin.users.profile.status.updateError': 'Güncelleme Başarısız',
  'admin.users.profile.status.updateErrorDescription': 'Kullanıcı durumu güncellenemedi. Lütfen tekrar deneyin.',
  
  'admin.users.profile.private.title': 'Özel Bilgiler',
  'admin.users.profile.private.subtitle': 'Gizli kullanıcı kişisel bilgileri',
  'admin.users.profile.private.email': 'E-posta',
  'admin.users.profile.private.phone': 'Telefon Numarası',
  'admin.users.profile.private.gender': 'Cinsiyet',
  'admin.users.profile.private.noData': 'Özel bilgiler mevcut değil.',
  
  'admin.users.profile.payment.title': 'Ödeme Yöntemleri',
  'admin.users.profile.payment.subtitle': 'Kullanıcının yapılandırılmış ödeme seçenekleri',
  'admin.users.profile.payment.crypto.title': 'Kripto Cüzdan',
  'admin.users.profile.payment.crypto.network': 'Ağ',
  'admin.users.profile.payment.crypto.currency': 'Para Birimi',
  'admin.users.profile.payment.crypto.address': 'Adres',
  'admin.users.profile.payment.noData': 'Yapılandırılmış ödeme yöntemi yok.',

  profileUserAccounts: 'Kullanıcı Hesapları',
  profileUserAccountsSubtitle: 'Trading hesapları ve yatırım detayları',
  profileAccountsTableAccountNumber: 'Hesap Numarası',
  profileAccountsTableAccountStatus: 'Hesap Durumu',
  profileAccountsTableAccountType: 'Hesap Türü',
  profileAccountsTableProgramPercent: 'Program Yüzdesi',
  profileAccountsTableBalance: 'Bakiye',
  profileAccountsTableCreationDate: 'Hesap Oluşturma',
  profileAccountsTableNoData: 'Hesap verisi mevcut değil',
  profileAccountsTableError: 'Hesap verileri yüklenirken hata',

  profileUserEarnings: 'Kullanıcı Kazanç Bilgileri',
  profileUserEarningsSubtitle: 'Kapsamlı kazanç ve kâr genel bakışı',
  profileEarningsError: 'Kazanç verileri yüklenirken hata',
  profileEarningsNoData: 'Kazanç verisi mevcut değil',
  
  'admin.users.profile.earnings.title': 'Kullanıcı Kazanç Bilgileri',
  'admin.users.profile.earnings.subtitle': 'Kapsamlı kazanç ve kâr genel bakışı',
  
  'admin.users.profile.historicEarnings.title': 'Kullanıcının Geçmiş Kazanç Bilgileri',
  'admin.users.profile.historicEarnings.subtitle': 'Hesap ve komisyon kazançlarının tam geçmiş görünümü',
  'admin.users.profile.historicEarnings.error.userIdRequired': 'Kazanç verilerini yüklemek için Kullanıcı Kimliği gereklidir',
  'admin.users.profile.historicEarnings.accountsHistory.title': 'Hesap Kâr Geçmişi',
  'admin.users.profile.historicEarnings.accountsHistory.subtitle': 'Kullanıcı yatırım hesaplarından geçmiş kâr verileri',
  'admin.users.profile.historicEarnings.accountsHistory.error': 'Hesap kâr geçmişi yüklenirken hata',
  'admin.users.profile.historicEarnings.commissionsHistory.title': 'Komisyon Kazanç Geçmişi',
  'admin.users.profile.historicEarnings.commissionsHistory.subtitle': 'Referans ağından geçmiş komisyon kazançları',
  'admin.users.profile.historicEarnings.commissionsHistory.error': 'Komisyon kazanç geçmişi yüklenirken hata',
  
  'admin.users.profile.paymentHistory.title': 'Kullanıcının Ödeme Geçmişi',
  'admin.users.profile.paymentHistory.subtitle': 'Komisyon ödemeleri ve işlemlerin tam kaydı',
  'admin.users.profile.paymentHistory.error.userIdRequired': 'Ödeme verilerini yüklemek için Kullanıcı Kimliği gereklidir',
  'admin.users.profile.paymentHistory.error.loadingData': 'Ödeme geçmişi verileri yüklenirken hata',

  'admin.users.communityLevels.title': 'Topluluk Kademeleri',
  'admin.users.communityLevels.subtitle': 'Hiyerarşik kademelere göre topluluk yapısını keşfedin',
  'admin.users.communityLevels.targetUser': 'Hedef Kullanıcı',
  'admin.users.communityLevels.level': 'Kademe',
  'admin.users.communityLevels.members': 'üye',
  'admin.users.communityLevels.total': 'toplam',
  'admin.users.communityLevels.active': 'Aktif',
  'admin.users.communityLevels.inactive': 'Pasif',
  'admin.users.communityLevels.treeLevel': 'Ağaç Kademesi',
  'admin.users.communityLevels.directReferrals': 'Doğrudan Referanslar',
  'admin.users.communityLevels.memberSince': 'Üyelik Başlangıcı',
  'admin.users.communityLevels.username': 'Kullanıcı Adı',
  'admin.users.communityLevels.name': 'Ad',
  'admin.users.communityLevels.country': 'Ülke',
  'admin.users.communityLevels.joinDate': 'Katılım Tarihi',
  'admin.users.communityLevels.status': 'Durum',
  'admin.users.communityLevels.loading': 'Yükleniyor...',
  'admin.users.communityLevels.loadMore': 'Daha Fazla Yükle',
  'admin.users.communityLevels.noMembers': 'Bu kademe için üye bulunamadı',
  'admin.users.communityLevels.errorLoading': 'Kademe verileri yüklenirken hata',
  'admin.users.communityLevels.errorLoadingData': 'Topluluk verileri yüklenirken hata',
  'admin.users.communityLevels.userNotFound': 'Kullanıcı bulunamadı',
  'admin.users.communityLevels.noCommunityData': 'Topluluk verisi mevcut değil',
  'admin.users.communityLevels.filters': 'Filtreler',
  'admin.users.communityLevels.statusFilter': 'Durum Filtresi',
  'admin.users.communityLevels.rankFilter': 'Rütbe Filtresi',
  'admin.users.communityLevels.allStatuses': 'Tüm Durumlar',
  'admin.users.communityLevels.allRanks': 'Tüm Rütbeler',
  'admin.users.communityLevels.communityStructure': 'Topluluk Yapısı',
};
